import { render } from "./PickupList.vue?vue&type=template&id=107a61ac"
import script from "./PickupList.vue?vue&type=script&lang=js"
export * from "./PickupList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__